import * as React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Person glyph for the Profile sidebar item (Figma "profile", node
 * 16306:68615): a 7×7 head centred at the top and a 14×7.5 shoulders shape
 * below, at the offsets the design gives inside the 16px icon box.
 *
 * `common/svgs/personIcon.tsx` draws the same shape but as a plain `<svg>` with
 * the primary colour baked in, so it can't take the sidebar's `sx`/`color` —
 * this is the SvgIcon version. The 18×18 viewBox with the art inset by 1 keeps
 * the ink at 16px when the sidebar renders at `fontSize: 18` (see
 * GridLayoutIcon for the full rationale).
 */
const ProfileIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <g transform="translate(5.5 1)">
      <path d="M3.5 7C5.433 7 7 5.433 7 3.5C7 1.567 5.433 0 3.5 0C1.567 0 0 1.567 0 3.5C0 5.433 1.567 7 3.5 7Z" />
    </g>
    <g transform="translate(2 9.5)">
      <path d="M7 0C5.14413 0.00211736 3.36489 0.740295 2.05259 2.05259C0.740295 3.36489 0.00211736 5.14413 0 7C0 7.13261 0.0526784 7.25979 0.146447 7.35355C0.240215 7.44732 0.367392 7.5 0.5 7.5H13.5C13.6326 7.5 13.7598 7.44732 13.8536 7.35355C13.9473 7.25979 14 7.13261 14 7C13.9979 5.14413 13.2597 3.36489 11.9474 2.05259C10.6351 0.740295 8.85587 0.00211736 7 0V0Z" />
    </g>
  </SvgIcon>
);

export default ProfileIcon;
